import { getApiClient } from './ApiClient'

export const translationJsonpathListPromise = (params) => {
  return getApiClient()
    .get('/translation-jsonpaths', { params })
    .then(resp => resp.data)
}

export const translationJsonpathDetailPromise = (id) => {
  return getApiClient()
    .get(`/translation-jsonpaths/${id}`)
    .then(resp => resp.data)
}

export const translationJsonpathCreatePromise = (body) => {
  return getApiClient()
    .post('/translation-jsonpaths', { body })
    .then(resp => resp.data)
}

export const translationJsonpathUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/translation-jsonpaths/${id}`, { body })
    .then(resp => resp.data)
}

export const translationJsonpathDeletePromise = (id) => {
  return getApiClient()
    .delete(`/translation-jsonpaths/${id}`)
    .then(resp => resp.data)
}
